// src/firebase/config.js
import { initializeApp } from 'firebase/app';
import { getDatabase } from 'firebase/database';

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyC-QZJSG9aPtL7PB3ejD4kwEiEwvOz6WSg",
  authDomain: "loadin-93058.firebaseapp.com",
  projectId: "loadin-93058",
  storageBucket: "loadin-93058.firebasestorage.app",
  messagingSenderId: "692822788598",
  appId: "1:692822788598:web:f1fafae4fa1be6ca1c1fd7"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Realtime Database
const database = getDatabase(app);

export { database };